import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <section className="flex flex-col items-center w-full py-12 text-center md:py-24">
      <div className="container flex flex-col items-center justify-center gap-2 px-4 md:gap-4 lg:gap-6">
        <div className="mx-auto">
            <h1 className="font-bold text-9xl mb-4 text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary border border-current">404</h1>
          <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl text-center mb-4">
            Lost in the clouds
          </h1>
          <p className="text-gray-500 md:w-2/4 lg:w-1/2 xl:w-1/3 dark:text-gray-400 text-center mx-auto">
            Whoops, looks like you took a wrong turn. Let&#x27;s get you back
            home.
          </p>
        </div>
        <Link to="/app">
          <Button
            variant="outline"
            className="mx-auto flex justify-center w-auto gap-2 items-center"
          >
            {/* <Plus className="h-6 w-6" /> */}
            Go back home
          </Button>
        </Link>
      </div>
    </section>
  );
}

export default NotFound;
